<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <p class="plan_item_title">
      <span>{{ data.title }}</span>
    </p>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <span class="qi">{{ el.qiShu }}期:</span>
        <div :class="{}">
          <span style="color: #0508e7">
            今期买【<span
              style="color: red; font-size: 150%"
              v-for="e in el.yuCe"
              :class="{ win: e === el.shengXiao }"
              >{{ e }}</span
            >】输尽光
          </span>
          <span style="margin-left: 12px; color: #19f51f"
            >开:
            <span style="color: #8e2c8a">{{
              el.ifZuiXin ? "??" : el.shengXiao
            }}</span>
            <span style="color: red">{{ el.ifWin ? "准" : "错" }}</span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background: #81007f;
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    color: #fff;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      padding: 5px 12px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      grid-gap: 10px;
      > div {
        display: flex;
        align-items: flex-end;
      }
      .win {
        color: #fff !important;
        background: #999;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>